<div class="flex min-w-0 flex-1 flex-col">
  <!-- Slot for things like breadcrumbs -->
  <ng-content select="[before-table]"></ng-content>

  <div class="flex-1">
    <aura-data-table
      matSort
      [inputColumns]="columns()"
      [filters]="filters()"
      [items]="items()"
      [count]="count()"
      [loading]="isLoading()"
      [pagination]="pagination()"
      [topButtons]="topButtons()"
      [itemActions]="itemActions()"
      [mappedFilters]="mappedFilters()"
      [hideSearch]="true"
      (removeFilter)="removeFilter()?.($event)"
      (clearFiltering)="clearFiltering()?.()"
      (triggerRefresh)="triggerRefresh()?.()"
      (triggerFiltering)="triggerFiltering()?.()"
      (filterViewChanged)="filterViewChanged()?.($event)"
      (itemClicked)="itemClicked()?.($event)"
      (pageChanged)="pageChanged()?.($event)"
      (searchChanged)="searchChanged()?.($event)"
      (matSortChange)="sortChanged()?.($event)"
    >
      <ng-template #filterTemplate>
        <core-subscriptions-data-table-filter
          [dto]="appliedFilter()"
          [filters]="filters()"
          [currentFilterView]="currentFilterView()"
          (filterChanged)="filterChanged()?.($event)"
        />
      </ng-template>

      @for (column of columns(); track $index) {
        @if (!column.native) {
          <ng-container [matColumnDef]="column.key">
            <th
              mat-header-cell
              *matHeaderCellDef
              mat-sort-header
              [sortActionDescription]="'Trier par ' + column.label | lowercase"
              class="font-bold text-primary"
            >
              {{ column.label }}
            </th>
            @switch (column.key) {
              @case ('user') {
                <td mat-cell *matCellDef="let sub">
                  @if (sub.user) {
                    <button
                      [matTooltip]="'Utilisateur'"
                      [routerLink]="['/users', sub.user._id]"
                      mat-button
                      class="link flex flex-row items-center"
                    >
                      <aura-avatar
                        [label]="$safeNavigationMigration(sub.user.identity?.firstName)"
                        [srcImage]="$safeNavigationMigration(sub.user.identity?.avatar?.url)"
                        [size]="'xs'"
                      />

                      <div class="ml-2">
                        {{ $safeNavigationMigration(sub.user.identity?.firstName) | titlecase }}
                        {{ $safeNavigationMigration(sub.user.identity?.lastName) | titlecase }}
                      </div>
                    </button>
                  }
                </td>
              }
              @case ('plan') {
                <td mat-cell *matCellDef="let sub">
                  @if (sub.plan) {
                    <div class="font-medium text-gray-12">{{ sub.plan.name }}</div>
                    <div class="text-xs text-gray-10">
                      {{ sub.plan.price | priceDisplay: sub.plan.currency }} / {{ sub.plan.billingCycle }}
                    </div>
                  }
                </td>
              }
              @case ('status') {
                <td mat-cell *matCellDef="let sub">
                  <div
                    class="inline-flex items-center gap-x-1.5 rounded-md bg-neutral-a4 px-1.5 py-0.5 text-sm font-medium"
                  >
                    <div
                      class="size-1.5 rounded-full"
                      [class.bg-green-9]="sub.status === 'active' || sub.status === 'trialing'"
                      [class.bg-amber-9]="sub.status === 'past_due' || sub.status === 'paused'"
                      [class.bg-red-9]="sub.status === 'canceled' || sub.status === 'unpaid'"
                      [class.bg-neutral-9]="
                        sub.status === 'incomplete' || sub.status === 'incomplete_expired'
                      "
                    ></div>
                    {{ sub.status | subscriptionStatusDisplay }}
                  </div>
                </td>
              }
              @case ('currentPeriodStart') {
                <td mat-cell *matCellDef="let sub">
                  {{ sub.currentPeriodStart | luxonDate: 'dd/LL/yyyy HH:mm' }}
                </td>
              }
              @case ('currentPeriodEnd') {
                <td mat-cell *matCellDef="let sub">
                  {{ sub.currentPeriodEnd | luxonDate: 'dd/LL/yyyy HH:mm' }}
                </td>
              }
              @case ('cancelAtPeriodEnd') {
                <td mat-cell *matCellDef="let sub">
                  @if (sub.cancelAtPeriodEnd) {
                    <div
                      class="inline-flex items-center gap-x-1.5 rounded-md bg-red-a3 px-1.5 py-0.5 text-sm font-medium text-red-11"
                    >
                      Oui
                    </div>
                  } @else {
                    <div
                      class="inline-flex items-center gap-x-1.5 rounded-md bg-green-a3 px-1.5 py-0.5 text-sm font-medium text-green-11"
                    >
                      Non
                    </div>
                  }
                </td>
              }
              @case ('createdAt') {
                <td mat-cell *matCellDef="let sub">
                  {{ sub.createdAt | luxonDate: 'humanize' }}
                </td>
              }
              @default {
                <td mat-cell *matCellDef="let sub">
                  {{ sub[column.key] }}
                </td>
              }
            }
          </ng-container>
        }
      }
    </aura-data-table>
  </div>
</div>
